<div class="kt-margin-l-25 d-flex" *ngIf="displayFilters.length">
  <span style="padding-top: 2px">Filtered By: </span>
  <button class="btn btn-xs btn-label-brand kt-margin-l-10" *ngFor="let filter of displayFilters" (click)="removeFilter(filter)">
    {{filter.title}} {{getType(filter.type)}} {{filter.value}}
    <i class="kt-margin-l-10 fa fa-times"></i>
  </button>
</div>